import React from "react";

import { formatDateLongWithWeekday } from "../../services/formatter";

// types
import { PaymentSummaryResponse } from "../../types/api/user";

type PaymentDetailsProps = {
  payments: PaymentSummaryResponse;
};

const PaymentDetails = ({ payments }: PaymentDetailsProps) => {
  const disbursement = payments.paymentDisbursements[0];

  const rows = [
    { label: payments.paymentType, value: payments.totalAmount },
    {
      label: "Date",
      value: formatDateLongWithWeekday(new Date(payments.disbursementDate)),
    },
    { label: "Account", value: disbursement?.displayName },
    { label: "Fee", value: disbursement?.feeAmount },
    { label: "Total", value: disbursement?.totalAmount },
  ];

  return (
    <div data-testid="payment-details">
      {rows.map((row, index) => (
        <div
          key={row.label}
          className={`flex-row py-4 justify-content-between font-size-lg leading-24 ${index === rows.length - 1 ? "" : "mb-8"
            }`}
        >
          <span className="text-primary">{row.label}</span>
          <span className="text-primary bold">{row.value}</span>
        </div>
      ))}
    </div>
  );
};

export default PaymentDetails;